module.exports = __webpack_public_path__ + "static/media/XORNNOutput.ffdaeeb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/codingProjects/resources/XORNNOutput.png
// module id = 650
// module chunks = 0